document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("recent-sales-popup");
  if (!popup) return;

  const delay = (parseInt(popup.dataset.delay, 10) || 15) * 1000;
  const salesDataNode =
    document.getElementById("popup-sales-data") ||
    document.getElementById("popup-products-data");
  let salesEntries = [];

  function toFirstName(name) {
    if (typeof name !== "string") return "";
    const cleanedName = name.replace(/\./g, " ").trim();
    if (!cleanedName) return "";
    return cleanedName.split(/\s+/)[0];
  }

  function createSeededRandom(seed) {
    let value = seed % 2147483647;

    if (value <= 0) {
      value += 2147483646;
    }

    return function nextRandom() {
      value = (value * 16807) % 2147483647;
      return (value - 1) / 2147483646;
    };
  }

  function getSequenceSeed(list) {
    const source = list
      .map(function (entry) {
        return `${entry.product}::${entry.customer}`;
      })
      .join("|");
    let hash = 0;

    for (let index = 0; index < source.length; index += 1) {
      hash = (hash * 31 + source.charCodeAt(index)) % 2147483647;
    }

    return hash || 1;
  }

  function shuffle(list, randomFn) {
    const copy = list.slice();
    for (let i = copy.length - 1; i > 0; i -= 1) {
      const j = Math.floor(randomFn() * (i + 1));
      const temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function buildSharedSequence(list) {
    const seededRandom = createSeededRandom(getSequenceSeed(list));
    const queue = shuffle(list, seededRandom);
    const sequence = [];
    let previousProduct = null;
    let productStreak = 0;

    while (queue.length) {
      let nextIndex = 0;

      if (
        previousProduct &&
        productStreak >= 2 &&
        queue[0].product === previousProduct
      ) {
        const alternativeIndex = queue.findIndex(function (entry, index) {
          return index > 0 && entry.product !== previousProduct;
        });

        if (alternativeIndex > 0) {
          nextIndex = alternativeIndex;
        }
      }

      const nextItem = queue.splice(nextIndex, 1)[0];
      sequence.push(nextItem);

      if (nextItem.product === previousProduct) {
        productStreak += 1;
      } else {
        previousProduct = nextItem.product;
        productStreak = 1;
      }
    }

    return sequence;
  }

  if (salesDataNode) {
    try {
      const parsedSales = JSON.parse(salesDataNode.textContent || "[]");
      if (Array.isArray(parsedSales)) {
        const seenEntries = {};

        salesEntries = parsedSales.reduce(function (entries, item) {
          if (
            !item ||
            typeof item.product !== "string" ||
            !Array.isArray(item.customers)
          ) {
            return entries;
          }

          const productTitle = item.product.trim();
          if (!productTitle) return entries;

          item.customers.forEach(function (customerName) {
            if (typeof customerName !== "string") return;

            const trimmedName = customerName.trim();
            if (!trimmedName) return;

            const firstName = toFirstName(trimmedName);
            if (!firstName) return;

            const entryKey = `${productTitle}::${firstName}`;
            if (seenEntries[entryKey]) return;

            seenEntries[entryKey] = true;
            entries.push({
              product: productTitle,
              customer: firstName
            });
          });

          return entries;
        }, []);
      }
    } catch (error) {
      salesEntries = [];
    }
  }

  if (!salesEntries.length) {
    salesEntries = [
  // Ayur Dibet customers
  { customer: "Rameshchandra B", product: "Ayur Dibet" },
  { customer: "Purushottam", product: "Ayur Dibet" },
  { customer: "Sunil", product: "Ayur Dibet" },
  { customer: "Shobha", product: "Ayur Dibet" },
  { customer: "Anita", product: "Ayur Dibet" },
  { customer: "Sunita C", product: "Ayur Dibet" },
  { customer: "Ritesh S", product: "Ayur Dibet" },
  { customer: "Shweta", product: "Ayur Dibet" },
  { customer: "Aarti", product: "Ayur Dibet" },
  { customer: "Sangita", product: "Ayur Dibet" },
  { customer: "Asha", product: "Ayur Dibet" },
  { customer: "Alka T", product: "Ayur Dibet" },
  { customer: "Siddharth J", product: "Ayur Dibet" },
  { customer: "Paresh", product: "Ayur Dibet" },
  { customer: "Akshay", product: "Ayur Dibet" },
  { customer: "Prashant", product: "Ayur Dibet" },
  { customer: "Kishor S", product: "Ayur Dibet" },
  { customer: "Ashok S", product: "Ayur Dibet" },
  { customer: "Sham", product: "Ayur Dibet" },
  { customer: "Manorma", product: "Ayur Dibet" },

  // Ayur Card customers
  { customer: "Kusum D", product: "Ayur Card" },
  { customer: "Seema", product: "Ayur Card" },
  { customer: "Revati", product: "Ayur Card" },
  { customer: "Kavita K", product: "Ayur Card" },
  { customer: "Datta", product: "Ayur Card" },
  { customer: "Sunita", product: "Ayur Card" },
  { customer: "Devika M", product: "Ayur Card" },
  { customer: "Manoj S", product: "Ayur Card" },
  { customer: "Deepa", product: "Ayur Card" },
  { customer: "Reshma", product: "Ayur Card" },
  { customer: "Neeta L", product: "Ayur Card" },
  { customer: "Sunita", product: "Ayur Card" },
  { customer: "Neeta", product: "Ayur Card" },
  { customer: "Pratima", product: "Ayur Card" },
  { customer: "Sangita D", product: "Ayur Card" },
  { customer: "Sanjay", product: "Ayur Card" },
  { customer: "Yogesh", product: "Ayur Card" },
  { customer: "Rajesh P", product: "Ayur Card" },
  { customer: "Pravin", product: "Ayur Card" },
  { customer: "Rajendra", product: "Ayur Card" },

  // Ayur X Sense customers
  { customer: "Nirmal T", product: "Ayur X Sense" },
  { customer: "Arjun", product: "Ayur X Sense" },
  { customer: "Vaibhav R", product: "Ayur X Sense" },
  { customer: "Gaurav", product: "Ayur X Sense" },
  { customer: "Priyanshu", product: "Ayur X Sense" },
  { customer: "Kartik S", product: "Ayur X Sense" },
  { customer: "Amit", product: "Ayur X Sense" },
  { customer: "Vikram", product: "Ayur X Sense" },
  { customer: "Sameer", product: "Ayur X Sense" },
  { customer: "Sarvesh", product: "Ayur X Sense" },
  { customer: "Kashish", product: "Ayur X Sense" },
  { customer: "Sumit M", product: "Ayur X Sense" },
  { customer: "Paresh", product: "Ayur X Sense" },
  { customer: "Shreyank", product: "Ayur X Sense" },
  { customer: "Pavitra P", product: "Ayur X Sense" },

  // Amla Juice customers
  { customer: "Shivani B", product: "Amla Juice" },
  { customer: "Rushikesh", product: "Amla Juice" },
  { customer: "Shrirang", product: "Amla Juice" },
  { customer: "Vaibhav", product: "Amla Juice" },
  { customer: "Samarth", product: "Amla Juice" },
  { customer: "Yogesh B", product: "Amla Juice" },
  { customer: "Yogendra", product: "Amla Juice" },
  { customer: "Sonal", product: "Amla Juice" },
  { customer: "Priyanka", product: "Amla Juice" },
  { customer: "Ashwini J", product: "Amla Juice" },
  { customer: "Maruti G", product: "Amla Juice" },
  { customer: "Pavan", product: "Amla Juice" },
  { customer: "Zainuddin", product: "Amla Juice" },
  { customer: "Rajesh", product: "Amla Juice" },
  { customer: "Ajit", product: "Amla Juice" },
  { customer: "Hyam", product: "Amla Juice" },
  { customer: "Ashok A", product: "Amla Juice" },

  // Aloevera Juice customers
  { customer: "Yask", product: "Aloevera Juice" },
  { customer: "Deepali T", product: "Aloevera Juice" },
  { customer: "Dhanashree", product: "Aloevera Juice" },
  { customer: "Suraj", product: "Aloevera Juice" },
  { customer: "Pooja", product: "Aloevera Juice" },
  { customer: "Gayatri P", product: "Aloevera Juice" },
  { customer: "Jagdish D", product: "Aloevera Juice" },
  { customer: "Pratik", product: "Aloevera Juice" },
  { customer: "Vaishali", product: "Aloevera Juice" },
  { customer: "Sangita S", product: "Aloevera Juice" },
  { customer: "Yash", product: "Aloevera Juice" },
  { customer: "Suyash", product: "Aloevera Juice" },
  { customer: "Shubham", product: "Aloevera Juice" },
  { customer: "Ajay K", product: "Aloevera Juice" },
  { customer: "Tejas", product: "Aloevera Juice" },
  { customer: "Rajan", product: "Aloevera Juice" },

  // Ayur Dibet Juice customers
  { customer: "Sandeep M", product: "Ayur Dibet Juice" },
  { customer: "Govindprasad", product: "Ayur Dibet Juice" },
  { customer: "Mukund", product: "Ayur Dibet Juice" },
  { customer: "Shamsundar", product: "Ayur Dibet Juice" },
  { customer: "Chaitanya", product: "Ayur Dibet Juice" },
  { customer: "Jagdish G", product: "Ayur Dibet Juice" },
  { customer: "Shreyas", product: "Ayur Dibet Juice" },
  { customer: "Kirtika", product: "Ayur Dibet Juice" },
  { customer: "Yashi", product: "Ayur Dibet Juice" },
  { customer: "Ramesh", product: "Ayur Dibet Juice" },
  { customer: "Rajesh", product: "Ayur Dibet Juice" },
  { customer: "Seema", product: "Ayur Dibet Juice" },
  { customer: "Saroj K", product: "Ayur Dibet Juice" },
  { customer: "Sunita M", product: "Ayur Dibet Juice" },
  { customer: "Hariprasad", product: "Ayur Dibet Juice" },
  { customer: "Raghunandan", product: "Ayur Dibet Juice" },
  { customer: "Jayesh K", product: "Ayur Dibet Juice" },
  { customer: "Prahladrai S", product: "Ayur Dibet Juice" },
  { customer: "Sheela G", product: "Ayur Dibet Juice" },
  { customer: "Shubham", product: "Ayur Dibet Juice" },
  { customer: "Sarang", product: "Ayur Dibet Juice" },
  { customer: "Prashant", product: "Ayur Dibet Juice" },
  { customer: "Shweta B", product: "Ayur Dibet Juice" },
  { customer: "Aditya D", product: "Ayur Dibet Juice" },

  // Ayur Card Juice customers
  { customer: "Omprakash M", product: "Ayur Card Juice" },
  { customer: "Bhagwan", product: "Ayur Card Juice" },
  { customer: "Anil", product: "Ayur Card Juice" },
  { customer: "Haresh J", product: "Ayur Card Juice" },
  { customer: "Mahesh", product: "Ayur Card Juice" },
  { customer: "Mahendra", product: "Ayur Card Juice" },
  { customer: "Manoj S", product: "Ayur Card Juice" },
  { customer: "Suresh K", product: "Ayur Card Juice" },
  { customer: "Govind M.", product: "Ayur Card Juice" },
  { customer: "Anil", product: "Ayur Card Juice" },
  { customer: "Milind", product: "Ayur Card Juice" },
  { customer: "Himanshu", product: "Ayur Card Juice" },
  { customer: "Manisha", product: "Ayur Card Juice" },
  { customer: "Vrushali", product: "Ayur Card Juice" },
  { customer: "Vandana", product: "Ayur Card Juice" },
  { customer: "Mamta", product: "Ayur Card Juice" },
  { customer: "Akshay P", product: "Ayur Card Juice" },
  { customer: "Prasad M", product: "Ayur Card Juice" },

  // Pachan Amrut Juice customers
  { customer: "Umesh B", product: "Pachan Amrut Juice" },
  { customer: "Ujwala", product: "Pachan Amrut Juice" },
  { customer: "Kanchan R", product: "Pachan Amrut Juice" },
  { customer: "Jyoti", product: "Pachan Amrut Juice" },
  { customer: "Kavita", product: "Pachan Amrut Juice" },
  { customer: "Rajeshri", product: "Pachan Amrut Juice" },
  { customer: "Tejas K", product: "Pachan Amrut Juice" },
  { customer: "Nikhil K.", product: "Pachan Amrut Juice" },
  { customer: "Ramkumar", product: "Pachan Amrut Juice" },
  { customer: "Shubham", product: "Pachan Amrut Juice" },
  { customer: "Puja", product: "Pachan Amrut Juice" },
  { customer: "Harish", product: "Pachan Amrut Juice" },
  { customer: "Pravin", product: "Pachan Amrut Juice" },
  { customer: "Tushar", product: "Pachan Amrut Juice" },
  { customer: "Swapnil D", product: "Pachan Amrut Juice" },
  { customer: "Ashok D", product: "Pachan Amrut Juice" },
  { customer: "Ashish", product: "Pachan Amrut Juice" },
  { customer: "Gokul B.", product: "Pachan Amrut Juice" },
  { customer: "Prajakta", product: "Pachan Amrut Juice" },
  { customer: "Sonal", product: "Pachan Amrut Juice" },
  { customer: "Nilesh", product: "Pachan Amrut Juice" },

  // Gulkand customers
  { customer: "Ratan J", product: "Gulkand" },
  { customer: "Arya", product: "Gulkand" },
  { customer: "Juhi G.", product: "Gulkand" },
  { customer: "Jagadeesh P", product: "Gulkand" },
  { customer: "Vikhyat", product: "Gulkand" },
  { customer: "Dinesh", product: "Gulkand" },
  { customer: "Gajanan", product: "Gulkand" },
  { customer: "Hariprasad", product: "Gulkand" },
  { customer: "Sakshi M", product: "Gulkand" },
  { customer: "Akash", product: "Gulkand" },
  { customer: "Aditi G.", product: "Gulkand" },
  { customer: "Priyanka S.", product: "Gulkand" },
  { customer: "Sanjay", product: "Gulkand" },
  { customer: "Atul", product: "Gulkand" },
  { customer: "Nipun", product: "Gulkand" },
      
  // Amlakand
  { customer: "Avni P", product: "Amlakand" },
  { customer: "Gauri T", product: "Amlakand" },
  { customer: "Shailesh B", product: "Amlakand" },
  { customer: "Monika L", product: "Amlakand" },
  { customer: "Girish", product: "Amlakand" },
  { customer: "Isha", product: "Amlakand" },
  { customer: "Mukund", product: "Amlakand" },
  { customer: "Hishesh R", product: "Amlakand" },
  { customer: "Mandar L", product: "Amlakand" },
  { customer: "Shweta", product: "Amlakand" },
  { customer: "Sushma R", product: "Amlakand" },
  { customer: "Rajesh D", product: "Amlakand" },

  // Amlakand with Jaggery
  { customer: "Shirish", product: "Amlakand with Jaggery" },
  { customer: "Manoj", product: "Amlakand with Jaggery" },
  { customer: "Pooja Z", product: "Amlakand with Jaggery" },
  { customer: "Sachin C", product: "Amlakand with Jaggery" },
  { customer: "Sadhana", product: "Amlakand with Jaggery" },
  { customer: "Sunita", product: "Amlakand with Jaggery" },
  { customer: "Pratiksha S", product: "Amlakand with Jaggery" },
  { customer: "Vrunda D", product: "Amlakand with Jaggery" },
  { customer: "Nikita G", product: "Amlakand with Jaggery" },
  { customer: "Deepa J", product: "Amlakand with Jaggery" },

  // Ostocure Pain Care Oil
  { customer: "Krishna M", product: "Ostocure Pain Care Oil" },
  { customer: "Rajendra B", product: "Ostocure Pain Care Oil" },
  { customer: "Pramod", product: "Ostocure Pain Care Oil" },
  { customer: "Pushpa", product: "Ostocure Pain Care Oil" },
  { customer: "Shubham", product: "Ostocure Pain Care Oil" },
  { customer: "Vishal R", product: "Ostocure Pain Care Oil" },
  { customer: "Subhash", product: "Ostocure Pain Care Oil" },
  { customer: "Reshma", product: "Ostocure Pain Care Oil" },
  { customer: "Pratik K", product: "Ostocure Pain Care Oil" },
  { customer: "Shivani T", product: "Ostocure Pain Care Oil" },
  { customer: "Kailash D", product: "Ostocure Pain Care Oil" },
  { customer: "Madhuri T", product: "Ostocure Pain Care Oil" },
  { customer: "Shyam", product: "Ostocure Pain Care Oil" },
  { customer: "Neeta", product: "Ostocure Pain Care Oil" },
  { customer: "Nidhi R", product: "Ostocure Pain Care Oil" },

  // Vedsparsh Hair Oil
  { customer: "Priya Z", product: "Vedsparsh Hair Oil" },
  { customer: "Vikram", product: "Vedsparsh Hair Oil" },
  { customer: "Yash M", product: "Vedsparsh Hair Oil" },
  { customer: "Rohan", product: "Vedsparsh Hair Oil" },
  { customer: "Rohit", product: "Vedsparsh Hair Oil" },
  { customer: "Siddharth", product: "Vedsparsh Hair Oil" },
  { customer: "Swati D", product: "Vedsparsh Hair Oil" },
  { customer: "Sachin", product: "Vedsparsh Hair Oil" },
  { customer: "Shalini S", product: "Vedsparsh Hair Oil" },
  { customer: "Govardhan B", product: "Vedsparsh Hair Oil" },

  // Coffee Herbal Soap
  { customer: "Shweta M", product: "Coffee Herbal Soap" },
  { customer: "Vaishnavi", product: "Coffee Herbal Soap" },
  { customer: "Sushma", product: "Coffee Herbal Soap" },
  { customer: "Priyanka H", product: "Coffee Herbal Soap" },
  { customer: "Priyanka T", product: "Coffee Herbal Soap" },
  { customer: "Samruddhi A", product: "Coffee Herbal Soap" },
  { customer: "Atul", product: "Coffee Herbal Soap" },
  { customer: "Shyam", product: "Coffee Herbal Soap" },
  { customer: "Shivam", product: "Coffee Herbal Soap" },
  { customer: "Mangal G", product: "Coffee Herbal Soap" },
  { customer: "Pooja D", product: "Coffee Herbal Soap" },
  { customer: "Anushree", product: "Coffee Herbal Soap" },
  { customer: "Shivansh", product: "Coffee Herbal Soap" },
  { customer: "Vivaan", product: "Coffee Herbal Soap" },
  { customer: "Vishnu H", product: "Coffee Herbal Soap" },
  { customer: "Nikhil", product: "Coffee Herbal Soap" },

  // Aloe Jasmine Soap
  { customer: "Gayatri D", product: "Aloe Jasmine Soap" },
  { customer: "Aditi G", product: "Aloe Jasmine Soap" },
  { customer: "Rahul K", product: "Aloe Jasmine Soap" },
  { customer: "Sneha", product: "Aloe Jasmine Soap" },
  { customer: "Priya", product: "Aloe Jasmine Soap" },
  { customer: "Ananya S", product: "Aloe Jasmine Soap" },
  { customer: "Rohan", product: "Aloe Jasmine Soap" },
  { customer: "Vikram A", product: "Aloe Jasmine Soap" },

  // Sandal Soap
  { customer: "Arya N", product: "Sandal Soap" },
  { customer: "Rajeshri", product: "Sandal Soap" },
  { customer: "Sunita S", product: "Sandal Soap" },
  { customer: "Sarvesh D", product: "Sandal Soap" },
  { customer: "Rohan", product: "Sandal Soap" },
  { customer: "Anita D", product: "Sandal Soap" },
  { customer: "Shivani B", product: "Sandal Soap" },
  { customer: "Ranjana R", product: "Sandal Soap" },
  { customer: "Saakshi S", product: "Sandal Soap" },

  // Goat Milk Soap
  { customer: "Harish A", product: "Goat Milk Soap" },
  { customer: "Sunita S", product: "Goat Milk Soap" },
  { customer: "Priti S", product: "Goat Milk Soap" },
  { customer: "Shreya", product: "Goat Milk Soap" },
  { customer: "Chitra", product: "Goat Milk Soap" },
  { customer: "Bhuvin Y", product: "Goat Milk Soap" },
  { customer: "Krishnamoorthy", product: "Goat Milk Soap" }
    ];
  }

  salesEntries = salesEntries.map(function (entry) {
    return {
      product: entry.product,
      customer: toFirstName(entry.customer)
    };
  }).filter(function (entry) {
    return entry.product && entry.customer;
  });

  const sharedSequence = buildSharedSequence(salesEntries);

  function getSlotIndex(now) {
    if (!sharedSequence.length) return 0;
    return Math.floor(now / delay) % sharedSequence.length;
  }

  function getSaleForTime(now) {
    return sharedSequence[getSlotIndex(now)] || null;
  }

  function getSynchronizedTimeLabel(now) {
    const minutes = (Math.floor(now / delay) % 59) + 1;
    return `${minutes} min ago`;
  }

  function renderPopup(now) {
    const sale = getSaleForTime(now);
    if (!sale) return;

    document.getElementById("popup-customer").innerText = sale.customer;
    document.getElementById("popup-product").innerText = sale.product;
    document.getElementById("popup-time").innerText = getSynchronizedTimeLabel(now);
  }

  function showPopup() {
    const now = Date.now();
    renderPopup(now);

    popup.style.display = "flex";

    const visibleDuration = Math.min(5000, delay);
    setTimeout(() => {
      popup.style.display = "none";
    }, visibleDuration);
  }

  popup.querySelector(".popup-close").addEventListener("click", function () {
    popup.style.display = "none";
  });

  const initialPopupDelay = 30000;

  setTimeout(function () {
    showPopup();
    setInterval(showPopup, delay);
  }, initialPopupDelay);
});
